import React, { useState, useContext } from 'react';
import {
  SORT_NONE,
  SORT_ASCENDING,
  SORT_DESCENDING,
} from './helper';
import {
  TABLE_HEADERS,
  TABLE_HEADERS_COMPACT,
  TableHeader,
} from './helper/ui-helper';
import PokedexTableRow from './PokedexTableRow';
import AppContext from './AppContext';

const sortDirectionString = (
  clickedHeader: TableHeader | null,
  sortDirection: number | null,
  header: TableHeader,
) => {
  if (clickedHeader == null
    || clickedHeader.name !== header.name
    || sortDirection === SORT_NONE
  ) return '';
  return sortDirection === SORT_ASCENDING ? ' ↑' : ' ↓';
};

function PokedexTable({
  isCompact,
  includeSprites,
}: {
  isCompact: boolean,
  includeSprites: boolean,
}) {
  const {
    dex: pokedex,
    filteredSpeciesIds: speciesIds,
  } = useContext(AppContext);
  const [clickedHeader, setClickedHeader] = useState<TableHeader | null>(null);
  const [sortDirection, setSortDirection] = useState<number | null>(null);
  const copiedSpeciesIds = [...speciesIds];
  const tableHeaders = isCompact ? TABLE_HEADERS_COMPACT : TABLE_HEADERS;

  if (clickedHeader != null && sortDirection !== SORT_NONE) {
    copiedSpeciesIds.sort((id1, id2) => {
      const value1 = clickedHeader.value(pokedex[id1]) || 'x';
      const value2 = clickedHeader.value(pokedex[id2]) || 'x';
      if (value1 > value2) return sortDirection === SORT_ASCENDING ? 1 : -1;
      if (value1 < value2) return sortDirection === SORT_ASCENDING ? -1 : 1;
      return 0;
    });
  }

  const rows = copiedSpeciesIds.map((speciesId, index) => (
    <PokedexTableRow
      includeSprites
      key={`tablerow-${speciesId}`}
      speciesId={speciesId}
      index={index}
      tableHeaders={tableHeaders}
    />
  ));

  const handleHeaderClick = (newlyClickedHeader: TableHeader) => {
    if (clickedHeader === newlyClickedHeader) {
      if (sortDirection === SORT_DESCENDING) {
        setSortDirection(SORT_NONE);
      } else if (sortDirection === SORT_NONE) {
        setSortDirection(SORT_ASCENDING);
      } else {
        setSortDirection(SORT_DESCENDING);
      }
    } else {
      setClickedHeader(newlyClickedHeader);
      setSortDirection(SORT_ASCENDING);
    }
  };

  const thClassName = 'py-3 px-1 text-xs text-left cursor-pointer font-semibold text-gray-700';
  return (
    <div className="border rounded-lg overflow-auto max-h-screen">
      <table className="row-selectable shadow min-w-full">
        <thead className="bg-gray-50 sticky top-0">
          <tr>
            {includeSprites ? <th>{null}</th> : null}
            {tableHeaders.map((header: TableHeader) => (
              <th
                key={`trth-${header.name}`}
                className={thClassName}
                onClick={() => handleHeaderClick(header)}
              >
                {`${header.name}${sortDirectionString(clickedHeader, sortDirection, header)}`}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="overflow-y-auto">
          {rows}
        </tbody>
      </table>
    </div>
  );
}

export default PokedexTable;
